import { Button, Grid } from "@mui/material";
import styles from "./QRCodeServey.module.css";
import SurveyTitle from "../../component/survey/SurveyTitle";
import SurveyBodyPageOne from "../../component/survey/SurveyBodyPageOne";
import SurveyBodyPageTwo from "../../component/survey/SurveyBodyPageTwo";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { ChangeSurveyChangeThunk } from "../../redux/common/navBar/thunkl";
import { ButtonDirection } from "../../interface/form";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import { ChangeDisclaimerFromSurveyThunk } from "../../redux/EnquiryForm/thunk";
import { ValidateEmail } from "../../util/form/form";

function QRCodeServey() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { surveyPage } = useSelector(
        (state: IRootState) => state.initNavBarState
    );

    const {
        disclaimer,
        name,
        tel,
        email,
        is_overfilled,
        is_others,
        othersRemark,
        fileList,
        need_inspection
    } = useSelector((state: IRootState) => state.enquiryFormInfoState);

    function handleClickStepButton(direction: ButtonDirection) {
        switch (direction) {
            case "next":
                if (!is_overfilled && !is_others) {
                    dispatch(OpenSnackBarWithResultFail("你未有填寫意見查詢"));
                    return;
                }

                if (is_others && !othersRemark){
                    dispatch(OpenSnackBarWithResultFail("你未有填寫其他原因"));
                    return;
                }

                if (email && !ValidateEmail(email)) {
                    dispatch(OpenSnackBarWithResultFail("並非有效電郵"));
                    return;
                }
                if (tel && tel.length !== 8) {
                    dispatch(OpenSnackBarWithResultFail("並非有效電話"));
                    return;
                }
                if (!disclaimer){
                    dispatch(
                        OpenSnackBarWithResultFail("你未有同意《收集個人資料聲明》")                        
                    );
                    return 
                }else{
                    dispatch(ChangeSurveyChangeThunk(surveyPage + 1));
                    return;
                }

            case "previous":
                dispatch(ChangeDisclaimerFromSurveyThunk(!disclaimer));
                dispatch(ChangeSurveyChangeThunk(surveyPage + -1));
                break;
        }
    }

    async function handleSubmit(){
        if (!fileList||fileList.length===0){
            dispatch(OpenSnackBarWithResultFail('你未有上載圖片'))
            return 
        }

        const form = new FormData ()

        fileList.forEach((file) => {
            form.append(`enquiryImages`, file);
        });
        form.append('is_overfilled',is_overfilled?"1":"0")
        form.append('is_others',is_others?"1":"0")
        form.append('name',name)
        form.append('email',email)
        form.append('tel',tel?tel:'')
        form.append('need_inspection',need_inspection)


        // to do insert api 
        // const result = await axiosPostWithFormData('/')
        


    }

    return (
        <>
            <Grid className={styles.SurveyOuterContainer}>
                <SurveyTitle />
                {surveyPage === 0 ? <SurveyBodyPageOne /> : <></>}

                {surveyPage === 0 ? (
                    <Grid>
                        <Button
                            className={styles.ButtonContainer}
                            style={{ backgroundColor: "#00bf6f " }}
                            variant="contained"
                            onClick={() => handleClickStepButton("next")}
                        >
                            下一步（Next）
                        </Button>
                    </Grid>
                ) : (
                    <></>
                )}

                {surveyPage === 1 ? <SurveyBodyPageTwo /> : <></>}

                {surveyPage === 1 ? (
                    <Grid className={styles.ButtonOuterContainer}>
                        <Button          
                            style={{ backgroundColor: "#00bf6f " }}
                            variant="contained"
                            onClick={() => handleClickStepButton("previous")}
                        >
                            上一步（Prev）
                        </Button>

                        <Button    
                            style={{ backgroundColor: "#00bf6f " }}
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            完成（Done）
                        </Button>
                    </Grid>
                ) : (
                    <></>
                )}
            </Grid>
        </>
    );
}

export default QRCodeServey;
